module.exports = __webpack_public_path__ + "static/media/sparkle.06a76880.ogg";